import { AuthApi } from '../../api/auth';
import jwt_decode from 'jwt-decode';
import router from '../../router';

const OIDC_CONFIG = {
    authorizationEndpoint: 'https://yandex-oidc.dev.rentateam.ru/authorize',
    clientId: 'b4e5a024925db6b8236475b18053ef00d08',
    scope: 'openid profile email',
};

function generateState() {
    return Math.random().toString(36).substring(2, 15);
}

export default {
    namespaced: true,
    state: {
        accessToken: {},
        user: null,
    },
    getters: {
        isAuthenticated: state => state.accessToken,
        accessToken: state => state.accessToken,
        oidcConfig: () => OIDC_CONFIG,
    },
    actions: {
        loginOidc: async ({ commit }, { code, redirectUri }) => {
            const { data: { access_token } } = await AuthApi.loginOidc(code, redirectUri);
            commit('setUser', jwt_decode(access_token));
            commit('setAccessToken', access_token);
            const redirectTo = router.currentRoute.value.query.redirect || '/';
            router.replace(redirectTo);
        },

        openOidcPopup: ({ getters }) => {
            return new Promise((resolve, reject) => {
                const state = generateState();
                const redirectUri = `${window.location.origin}/auth/callback`;

                const params = new URLSearchParams({
                    client_id: getters.oidcConfig.clientId,
                    redirect_uri: redirectUri,
                    response_type: 'code',
                    scope: getters.oidcConfig.scope,
                    state: state,
                });

                const authUrl = `${getters.oidcConfig.authorizationEndpoint}?${params.toString()}`;

                const width = 500;
                const height = 600;
                const left = window.screenX + (window.outerWidth - width) / 2;
                const top = window.screenY + (window.outerHeight - height) / 2;

                const popup = window.open(
                    authUrl,
                    'oidc-login',
                    `width=${width},height=${height},left=${left},top=${top}`
                );

                const handleMessage = (event) => {
                    if (event.origin !== window.location.origin) return;

                    if (event.data.type === 'oidc-callback') {
                        window.removeEventListener('message', handleMessage);
                        if (popup) popup.close();

                        if (event.data.code) {
                            resolve({ code: event.data.code, redirectUri });
                        } else if (event.data.error) {
                            reject(new Error(event.data.error));
                        }
                    }
                };

                window.addEventListener('message', handleMessage);

                const checkClosed = setInterval(() => {
                    if (popup && popup.closed) {
                        clearInterval(checkClosed);
                        window.removeEventListener('message', handleMessage);
                        reject(new Error('Popup closed'));
                    }
                }, 500);
            });
        },

        logout: ({ commit }) => {
            commit('setUser', {});
            commit('setAccessToken', null);
            router.replace({ name: 'login', query: { redirect: router.currentRoute.value.fullPath } });
        },
    },
    mutations: {
        setUser: (state, user) => {
            state.user = user;
        },
        setAccessToken: (state, accessToken) => {
            state.accessToken = accessToken;
        },
    },
};
